module.exports = __webpack_public_path__ + "img/menu.4d1a36d5.svg";